import React from "react";

const LeafDiagonal = () => {
  return (
    <svg viewBox="0 0 418 419" fill="none" >
      <path fill="#96D0A5" d="M0 209.013c0-115.428 93.572-209 209-209h209v209c0 115.427-93.572 209-209 209H0v-209Z"/>
    </svg>
  )
}

export default LeafDiagonal